/* Product share control.
 *
 * One button, two behaviours: the native share sheet where the browser has it (which on mobile already
 * offers Telegram and Messenger - the two places Cambodian shoppers actually send links), and a copy-to-
 * clipboard fallback on desktop. Deliberately not a row of social buttons: that is five extra network
 * requests to say what the OS sheet says better.
 *
 * Kept in its own file rather than added to mstore-product-modern.js: that file holds the variant class,
 * and a syntax error in a class is silent and total, so a standalone enhancement stays standalone.
 */
(() => {
  if (window.__msShare) return;
  window.__msShare = true;

  const flash = (btn, msg) => {
    const el = btn.querySelector('[data-share-msg]');
    if (!el) return;
    el.hidden = false;
    clearTimeout(btn.__msShareTimer);
    btn.__msShareTimer = setTimeout(() => { el.hidden = true; }, 1800);
  };

  const copy = async (text) => {
    try {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(text);
        return true;
      }
    } catch (err) { /* fall through to the legacy path */ }
    try {
      const ta = document.createElement('textarea');
      ta.value = text;
      ta.setAttribute('readonly', '');
      ta.style.position = 'fixed';
      ta.style.top = '-1000px';
      document.body.appendChild(ta);
      ta.select();
      const ok = document.execCommand('copy');
      document.body.removeChild(ta);
      return ok;
    } catch (err) {
      return false;
    }
  };

  const init = () => {
    document.querySelectorAll('[data-mstore-share]').forEach((btn) => {
      if (btn.dataset.msShareBound === '1') return;
      btn.dataset.msShareBound = '1';
      btn.addEventListener('click', async () => {
        const title = btn.getAttribute('data-share-title') || document.title;
        const url = window.location.href;
        if (navigator.share) {
          try {
            await navigator.share({ title, url });
            return;
          } catch (err) {
            /* the shopper dismissed the sheet, or share is unavailable - fall through to copy */
            if (err && err.name === 'AbortError') return;
          }
        }
        const ok = await copy(url);
        flash(btn, ok);
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  window.addEventListener('load', init);
  document.addEventListener('shopify:section:load', init);
})();
